<template>
    <div class="o-view">
        <div class="o-view-bg"></div>
        <div class="avatar-content">
            <img v-for="(item, i) in 4" :class="`avatar-icon avatar-icon-${item}`" :key="i" src="@/assets/temimg8/human-icon.png">
            <img :src="defaultlist.value1" alt="">
        </div>
        <div class="o-view-right">
            <div class="otext1" v-if="defaultlist.value2">{{ defaultlist.value2 }}</div>
            <div class="otext2 more-line2" v-if="defaultlist.value3">{{ defaultlist.value3 }}</div>
            <div class="otext2" v-if="defaultlist.value4" :title="defaultlist.value4">{{ defaultlist.value4 }}</div>
            <div class="otext2 more-line" v-if="defaultlist.value5" ref="autoplay">{{ defaultlist.value5 }}</div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";

export default {
    name: "template.scope82",
    props: {
        vdata: {
            type: [Array, String],
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        scopedata: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            defaultdata: [
                { value1: 'http://121.4.173.197:8000/defaultimg/default11.png', value2: '名称', value3: '地址', value4: '介绍', value5: '详情' }
            ],
            valueMap: [
                { name: '图片地址', key: 'value1' },
                { name: '文本一', key: 'value2' },
                { name: '文本二', key: 'value3' },
                { name: '文本三', key: 'value4' },
                { name: '文本四', key: 'value5' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            config: {},
            timer: null,
            timer1: null
        }
    },
    computed: {
        defaultlist() {
            let list = this.defaultdata[0]
            return list
        }
    },
    methods: {
        ...methods,
        autoplay() {
            const dom = this.$refs.autoplay
            const _this = this
            this.timer = setInterval(() => {
                if (dom.scrollTop >= dom.scrollHeight - 90) {
                    clearInterval(this.timer)
                    this.timer = null
                    this.timer1 = setTimeout(() => {
                        dom.scrollTop = 0
                        _this.autoplay()
                    }, 2000);
                } else {
                    dom.scrollTop += 2
                }
            }, 150);
        }
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        let host = window.location.host
        if (host == 'www.17886.cn') {
        let news = 'https://www.17886.cn'
        let olds = 'http://121.4.173.197:8000'
        this.defaultdata.forEach(item => {
            if (item.value1.includes(olds)) {
                item.value1 = item.value1.replace(olds, news)
                }
            })
            this.defaultdata = [...this.defaultdata]
        }
        this.setData()
        setTimeout(() => {
            this.autoplay()
        }, 200);
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
        clearTimeout(this.timer1)
        this.timer1 = null
    }
}
</script>

<style lang="scss" scoped>
.o-view {
    width: 435px;
    height: 240px;
    padding: 10px 0;
    display: flex;
    align-items: center;

    .avatar-content {
        width: 146px;
        height: 192px;
        border: 2px solid RGBA(48, 94, 155, 1);
        margin-left: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        background: #000;
        img {
            width: 140px;
            height: 186px;
            object-fit: cover;
        }
        .avatar-icon {
            width: 18px;
            height: 18px;
            position: absolute;
            animation: linght 2s linear infinite;
        }
        @keyframes linght {
            0% {
                opacity: 1;
            }
            50% {
                opacity: 0.3;
            }
            100% {
                opacity: 1;
            }
        }
        .avatar-icon-1 {
            left: -6px;
            top: -6px;
            transform: rotate(180deg);
        }
        .avatar-icon-2 {
            right: -6px;
            top: -6px;
            transform: rotate(-90deg);
        }
        .avatar-icon-3 {
            right: -6px;
            bottom: -6px;
        }
        .avatar-icon-4 {
            left: -6px;
            bottom: -6px;
            transform: rotate(90deg);
        }
    }

    .o-view-right {
        margin-left: 26px;
        max-width: 208px;
        color: #fff;

        .otext1 {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            line-height: 16px;
        }

        .otext2 {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            margin-top: 12px;
            line-height: 14px;
            max-width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            &.more-line2 {
                line-height: 24px;
                max-width: 100%;
                max-height: 48px;
                overflow-y: auto;
                white-space: normal;
            }
            &.more-line {
                line-height: 24px;
                max-width: 100%;
                max-height: 90px;
                overflow-y: auto;
                white-space: normal;
            }
        }
    }

    .o-view-bg {
        width: 429px;
        height: 230px;
        position: absolute;
        border-bottom: 2px solid #2D8DFF;
        background: linear-gradient(to top, #0355B1, transparent);
        z-index: -1;
    }
}
</style>